<div class="layout-body">
  <div class="layout-container flex flex-column h-screen">
    @if (!isOnPayment) {
      @if ($isAuthLoaded()) {
        <app-topbar
          *ngIf="
            $loggedIn() &&
            $currentUser()?.company?.web_theme &&
            !isDefaultTheme() &&
            !isNewTheme()
          "
          class="sticky-top"
        ></app-topbar>
        <app-topbar-new
          *ngIf="
            $loggedIn() && $currentUser()?.company?.web_theme && isNewTheme()
          "
          class="sticky-top"
        ></app-topbar-new>
        <app-topbar-B2B
          class="sticky-top"
          *ngIf="
            $loggedIn() &&
            $currentUser()?.company?.web_theme &&
            isDefaultTheme()
          "
        ></app-topbar-B2B>
      }
      <app-sidebar *ngIf="$loggedIn()"></app-sidebar>
    }
    <div class="layout-content-wrapper">
      <ng-content></ng-content>
    </div>
  </div>
  @if (!isOnPayment) {
    <div class="layout-footer">
      <app-footer-B2B *ngIf="$loggedIn() && isDefaultTheme()"></app-footer-B2B>
      <app-footer
        *ngIf="!isLogging && $loggedIn() && !isDefaultTheme()"
      ></app-footer>
    </div>
  }
</div>

@if ($currentUser()?.company?.ai_assitant === 1) {
  @if ($isAiAssistantOpen()) {
    <section
      class="ai-assistant-panel"
      [class.expanded]="$isAiAssistantExpanded()"
      aria-label="AI Assistant"
    >
      <div class="ai-assistant-header">
        <div class="ai-assistant-title">
          <div>
            <span>Online Assistant</span>
          </div>
        </div>
        <div class="ai-assistant-header-actions">
          <button
            type="button"
            class="ai-assistant-new-chat"
            [disabled]="$isAiAssistantLoading()"
            (click)="startNewAiAssistantChat()"
          >
            <i class="pi pi-plus" aria-hidden="true"></i>
            New chat
          </button>
          <button
            type="button"
            class="ai-assistant-expand"
            [attr.aria-label]="
              $isAiAssistantExpanded()
                ? 'Restore AI Assistant size'
                : 'Expand AI Assistant'
            "
            [attr.title]="
              $isAiAssistantExpanded()
                ? 'Restore chat size'
                : 'Expand chat to 50%'
            "
            [attr.aria-pressed]="$isAiAssistantExpanded()"
            (click)="toggleAiAssistantExpanded()"
          >
            <i
              class="pi"
              [class.pi-window-maximize]="!$isAiAssistantExpanded()"
              [class.pi-window-minimize]="$isAiAssistantExpanded()"
              aria-hidden="true"
            ></i>
          </button>
          <button
            type="button"
            class="ai-assistant-close"
            aria-label="Close AI Assistant"
            (click)="toggleAiAssistant()"
          >
            <i class="pi pi-times" aria-hidden="true"></i>
          </button>
        </div>
      </div>

      <div #aiAssistantContent class="ai-assistant-content">
        @if ($aiAssistantMessages().length === 0) {
          <div class="ai-assistant-empty">
            <i class="pi pi-comments" aria-hidden="true"></i>
            <strong>What would you like to print?</strong>
            <span>Ask me to find products, prices, and available options.</span>
            <small>Try: “I need 500 business cards.”</small>
          </div>
        }

        @for (message of $aiAssistantMessages(); track $index) {
          <div
            class="ai-assistant-message"
            [class.user]="message.role === 'user'"
          >
            <div class="ai-assistant-bubble">
              @for (
                segment of getAiAssistantMessageSegments(message.content);
                track $index
              ) {
                @if (segment.type === 'text') {
                  <span>{{ segment.text }}</span>
                } @else if (segment.type === 'bold') {
                  <span class="ai-assistant-bold">{{ segment.text }}</span>
                } @else if (segment.type === 'product') {
                  <span class="ai-assistant-product-actions">
                    <a [routerLink]="segment.url">{{ segment.text }}</a>
                    <button
                      type="button"
                      [disabled]="$isAiAssistantLoading()"
                      (click)="
                        showAiAssistantProductDetail(
                          segment.productName,
                          segment.url
                        )
                      "
                    >
                      Show detail
                    </button>
                  </span>
                } @else if (segment.type === 'card') {
                  <article class="ai-assistant-product-card">
                    <a
                      class="ai-assistant-product-card-image"
                      [routerLink]="segment.url"
                    >
                      @if (segment.imageUrl) {
                        <img
                          [src]="getAiAssistantProductImage(segment.imageUrl)"
                          [alt]="segment.productName"
                        />
                      } @else {
                        <i class="pi pi-image"></i>
                      }
                    </a>
                    <div class="ai-assistant-product-card-content">
                      <a
                        class="ai-assistant-product-card-name"
                        [routerLink]="segment.url"
                      >
                        {{ segment.productName }}
                      </a>
                      @if (segment.price) {
                        <strong class="ai-assistant-product-card-price">
                          From {{ formatAiAssistantPrice(segment.price) }}
                        </strong>
                      }
                      @if (segment.reason) {
                        <p>{{ segment.reason }}</p>
                      }
                      @if (segment.review) {
                        <small>{{ segment.review }}</small>
                      }
                      <a
                        class="ai-assistant-product-card-link"
                        [routerLink]="segment.url"
                      >
                        View detail
                      </a>
                    </div>
                  </article>
                } @else if (segment.type === 'detail') {
                  <article class="ai-assistant-product-detail">
                    @if (segment.imageUrl) {
                      <img
                        class="ai-assistant-product-detail-image"
                        [src]="getAiAssistantProductImage(segment.imageUrl)"
                        [alt]="segment.productName"
                      />
                    }
                    <div class="ai-assistant-product-detail-header">
                      <span>Product details</span>
                      <strong>{{ segment.productName }}</strong>
                    </div>

                    @if (segment.price) {
                      <div class="ai-assistant-product-detail-price">
                        <small>Starting price</small>
                        <strong>{{
                          formatAiAssistantPrice(segment.price)
                        }}</strong>
                      </div>
                    }

                    @if (segment.optionNames?.length) {
                      <div class="ai-assistant-product-detail-options">
                        <small>Available options</small>
                        <div>
                          @for (
                            optionName of segment.optionNames ?? [];
                            track optionName
                          ) {
                            <span>{{ optionName }}</span>
                          }
                        </div>
                      </div>
                    }

                    <a
                      class="ai-assistant-product-detail-link"
                      [routerLink]="segment.url"
                    >
                      View product
                      <i class="pi pi-arrow-right"></i>
                    </a>
                  </article>
                } @else {
                  <a
                    [href]="segment.url"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {{ segment.text }}
                  </a>
                }
              }
              @if (
                message.role === 'assistant' &&
                $isAiAssistantLoading() &&
                $last &&
                !message.content
              ) {
                <span class="ai-assistant-typing">Assistant thinking…</span>
              }
            </div>
          </div>
        }

        @if (
          $showShoppingAdviceSuggestion() ||
          $showAiAssistantSuggestions() ||
          $showAiAssistantGuestSuggestions()
        ) {
          <div class="ai-assistant-suggestions">
            <div>
              @if ($showShoppingAdviceSuggestion()) {
                <button
                  type="button"
                  [disabled]="$isAiAssistantLoading()"
                  (click)="startAiAssistantShoppingAdvice()"
                >
                  <i class="pi pi-shopping-bag" aria-hidden="true"></i>
                  <span>Shopping advice</span>
                </button>
                <button
                  type="button"
                  [disabled]="$isAiAssistantLoading()"
                  (click)="openAiAssistantReportProblem()"
                >
                  <i class="pi pi-exclamation-circle" aria-hidden="true"></i>
                  <span>Report a problem</span>
                </button>
              }
              @if ($showAiAssistantSuggestions()) {
                <button
                  type="button"
                  [disabled]="$isAiAssistantLoading()"
                  (click)="sendAiAssistantMessage('Search order by PO number')"
                >
                  <i class="pi pi-box" aria-hidden="true"></i>
                  <span>Search order by PO number</span>
                </button>
              }
              @if ($showAiAssistantGuestSuggestions()) {
                <button type="button" (click)="openAiAssistantForgotPassword()">
                  <i class="pi pi-lock" aria-hidden="true"></i>
                  <span>Forgot password</span>
                </button>
                <button type="button" (click)="openAiAssistantLogin()">
                  <i class="pi pi-sign-in" aria-hidden="true"></i>
                  <span>Login</span>
                </button>
              }
            </div>
          </div>
        }

        @if ($showReportProblemOptions()) {
          <div class="ai-assistant-report-options">
            <button
              type="button"
              (click)="
                selectAiAssistantReportProblem('Order is late', 'ORDER_LATE')
              "
            >
              Order is late
            </button>
            <button
              type="button"
              (click)="
                selectAiAssistantReportProblem(
                  'Order didn’t arrive',
                  'ORDER_NOT_RECEIVED'
                )
              "
            >
              Order didn’t arrive
            </button>
            <button
              type="button"
              (click)="
                selectAiAssistantReportProblem(
                  'Order is incorrect',
                  'ORDER_INCORRECT'
                )
              "
            >
              Order is incorrect
            </button>
            <button
              type="button"
              (click)="
                selectAiAssistantReportProblem(
                  'Missing products',
                  'PRODUCTS_MISSING'
                )
              "
            >
              Missing products
            </button>
            <button
              type="button"
              (click)="
                selectAiAssistantReportProblem(
                  'I’m not happy with my product',
                  'PRODUCT_DISSATISFACTION'
                )
              "
            >
              I’m not happy with my product
            </button>
            <button
              type="button"
              (click)="
                selectAiAssistantReportProblem(
                  'Order arrived damaged',
                  'ORDER_DAMAGED'
                )
              "
            >
              Order arrived damaged
            </button>
          </div>
        }

        @if ($showContactConfirmation()) {
          <div class="ai-assistant-contact-confirmation">
            <span>Would you like to send a contact request?</span>
            <div>
              <button
                type="button"
                [disabled]="$isContactRequestSending()"
                (click)="sendAiAssistantContactRequest()"
              >
                {{ $isContactRequestSending() ? 'Sending...' : 'Yes' }}
              </button>
              <button
                type="button"
                [disabled]="$isContactRequestSending()"
                (click)="declineAiAssistantContactRequest()"
              >
                No
              </button>
            </div>
          </div>
        }

        @if ($showHumanAgent()) {
          <button
            type="button"
            class="ai-assistant-human-agent"
            (click)="openAiAssistantContactForm()"
          >
            Contact a human agent
          </button>
        }
      </div>

      <div class="ai-assistant-input">
        <div class="ai-assistant-input-field">
          <input
            type="text"
            placeholder="Ask about a product..."
            aria-label="Message"
            [(ngModel)]="aiAssistantInput"
            [disabled]="$isAiAssistantLoading()"
            (keydown)="onAiAssistantKeydown($event)"
          />
          <button
            type="button"
            aria-label="Send message"
            [disabled]="$isAiAssistantLoading() || !aiAssistantInput.trim()"
            (click)="sendAiAssistantMessage()"
          >
            <i class="pi pi-send" aria-hidden="true"></i>
          </button>
        </div>
      </div>
    </section>
  }

  <button
    type="button"
    class="ai-assistant-trigger"
    aria-label="AI Assistant"
    [attr.aria-expanded]="$isAiAssistantOpen()"
    (click)="toggleAiAssistant()"
  >
    <i class="pi pi-sparkles" aria-hidden="true"></i>
  </button>
}

<p-dialog
  [draggable]="false"
  [modal]="true"
  [(visible)]="splash_status"
  styleClass="dialog-responsive "
  class="splash-page"
  [closable]="true"
  [closeOnEscape]="true"
  [dismissableMask]="true"
  (onHide)="closeSplash()"
>
  <div>
    <a
      (click)="viewSlashUrl()"
      href="#"
      style="cursor: pointer; width: fit-content"
    >
      <img
        src="{{ splash_image | assetUrl }}"
        style="max-width: 100%; max-height: 500px"
      />
    </a>
    <!-- @if (splash_file) {
          <a target="_blank" href="{{ splash_file | assetUrl }}"
            >Download file</a
          >
        }
        <div>
          <p-button
            label="Close"
            [rounded]="true"
            [style]="{ width: '100%', 'font-size': '15px' }"
            (click)="closeSplash()"
            styleClass="border-round border-2 transition-colors hover:surface-900 hover:border-900 checkout-button"
          ></p-button>
        </div> -->
  </div>
</p-dialog>
